Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    COLORS = _STYLES$useStyles.COLORS,
    fontRegular = _STYLES$useStyles.fontRegular;
  var barChart = {
    marginTop: spacing.xxl,
    marginBottom: spacing.xxl
  };
  if (bp.desktop) {
    barChart.marginTop = 0;
  }
  var heading = {};
  if (bp.desktop) {
    heading.textAlign = 'left';
  }
  var message = {
    width: '100%',
    maxWidth: _styles.STYLES.grid.maxTextBlockWidth,
    marginBottom: spacing.xxl,
    backgroundColor: COLORS.snuff,
    borderRadius: (0, _styles.getREM)(1),
    padding: spacing.normal,
    paddingBottom: 0
  };
  var textContainer = {
    textAlign: 'left',
    marginBottom: spacing.normal
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s])) {
    message.padding = spacing.s;
    textContainer.marginBottom = spacing.s;
  }
  if (bp.tablet) {
    message.padding = spacing.m;
    textContainer.marginBottom = spacing.m;
  }
  if (bp.desktop) {
    message.padding = spacing.l;
    textContainer.marginBottom = spacing.l;
  }
  var text = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: COLORS.aubergine
  });
  if (bp.tablet) {
    text.fontSize = _styles.STYLES.fontSize.normal;
    text.lineHeight = _styles.STYLES.lineHeight.normal;
  }
  if (bp.desktop) {
    text.fontSize = _styles.STYLES.fontSize.m;
    text.lineHeight = _styles.STYLES.lineHeight.m;
  }
  var styles = _reactNative.StyleSheet.create({
    barChart: barChart,
    heading: heading,
    message: message,
    textContainer: textContainer,
    text: text
  });
  return {
    styles: styles
  };
};